import React from "react"
import PropTypes from "prop-types"


class WeeklyWritingTextArea extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      text: '',
      title: ''
    }
    this.onChange = this.onChange.bind(this)
    this.titleText = this.titleText.bind(this)
  }

  onChange(event) {
    this.props.updateWritingText(event.target.value)
  }

  componentDidMount() {
    if(this.props.topic != undefined) {
      this.setState({
        title: this.props.topic.title
      })
    } else {
      //ajax call to get topic information
    }
  }

  titleText() {
    if(this.props.writeMoreError === true) {
      return(<h5 style={{color: '#E57373', textAlign: 'center', marginBottom: 12, fontWeight: 600}}>Try writing a little more...</h5>)
    }
    return(<h5 className="darkBlue" style={{textAlign: 'center', marginBottom: 12, fontWeight: 600, backgroundColor: 'rgba(1, 87, 155, 0.1)', padding: 15}}>{this.state.title}</h5>)

  }


  render() {
    return(
      <div >
        {this.titleText()}
        <textarea
          className="input_standard"
          onChange={this.onChange}
          text={this.props.searchText}
          value={this.props.text}
          placeholder={this.props.placeholder}
        >
       </textarea>
      </div>
    )
  }

}

export default WeeklyWritingTextArea;
